import frontBumper from '../assets/images/branik prednji.png';
import rearBumper from '../assets/images/branik zadnji.png';
import rightFrontLight from '../assets/images/far desni.png';
import leftFrontLight from '../assets/images/far levi.png';
import rightFrontWing from '../assets/images/krilo prednje desno.png';
import leftFrontWing from '../assets/images/krilo prednje levo.png';
import rightBackWing from '../assets/images/krilo zadnje desno.png';
import leftBackWing from '../assets/images/krilo zadnje levo.png';
import roof from '../assets/images/krov.png';
import hood from '../assets/images/poklopac motora.png';
import trunk from '../assets/images/poklopac zadnji.png';
import rightFrontWheel from '../assets/images/tochak prednji desni.png';
import leftFrontWheel from '../assets/images/tochak prednji levi.png';
import rightBackWheel from '../assets/images/tochak zadnji desni.png';
import leftBackWheel from '../assets/images/tochak zadnji levi.png';
import windshield from '../assets/images/vetrobransko staklo.png';
import rightFrontDoor from '../assets/images/vrata prednja desna.png';
import leftFrontDoor from '../assets/images/vrata prednja leva.png';
import rightBackDoor from '../assets/images/vrata zadnja desna.png';
import leftBackDoor from '../assets/images/vrata zadnja leva.png';
import backGlass from '../assets/images/zadnje staklo.png';
import rightBackLight from '../assets/images/zadnje svetlo desno.png';
import leftBackLight from '../assets/images/zadnje svetlo levo.png';

export const translations = {
    VEHICLE: 'Vozilo',
    LICENCE_PLATE: 'Registarska oznaka',
    VEHICLE_ID_NUMBER: 'Broj šasije vozila',
    POLICY: 'Polisa *',
    POLICY_NUMBER: 'Broj polise',
    CHASSIS_NUMBER: 'Broj šasije',
    POLICY_OR_CHASSIS_NUMBER: ' Broj polise ili broj šasije vozila *',
    DATE: 'Datum *',
    TIME: 'Vreme',
    HOUR: 'Sat *',
    MINUTE: 'Minut *',
    COUNTRY: 'Država *',
    CITY: 'Mesto *',
    STREET: 'U ulici - na relaciji *',
    TIME_PERIOD: 'Period važenja',
    VEHICLE_BRAND_AND_TYPE: 'Marka i tip vozila',
    PLEASE_PICK: 'Molimo izaberite',
    TIME_OF_OCCURANCE: 'Vreme nastanka',
    POLICY_OR_CHASSIS_NUMBER_SUBTITLE: 'Unesite broj polise ili broj šasije',
    POLICY_NUMBER_TOOLTIP: 'Unesite broj polise',
    POLICY_OR_CHASSIS_NUMBER_TOOLTIP_1: 'Broj kasko polise sadrži tačno 6 cifara.',
    POLICY_OR_CHASSIS_NUMBER_TOOLTIP_2: 'Broj šasije nikada ne sadrži slova I, O i Q.',
    CHASSIS_NUMBER_EXCEPTION:
        'Obavezan unos ako je po polisi osiguranja osigurano više vozila (grupna polisa). Broj šasije nikada ne sadrži slova I, O i Q',
    VEHICLE_PARKED: 'Da li je vozilo u vreme nastanka štete bilo parkirano? *',
    EU_TRAFFIC_ACCIDENT: 'Da li je popunjavan evropski izveštaj o saobraćajnoj nezgodi? *',
    WAS_POLICE_NOTIFIED: 'Da li je događaj prijavljen policiji? *',
    POLICE_ON_SCENE: 'Da li je policija izašla na lice mesta? *',
    POLICE_INVESTIGATION: 'Da li je policija obavila uviđaj saobraćajne nezgode? *',
    POLICE_ALCO_TEST: 'Da li je policija radila alko-test? *',
    DESCRIBE_EVENT: 'Ukratko opišite kako je došlo do štetnog događaja *',
    PLACE_OF_OCCURANCE: 'Mesto nastanka',
    CIRCUMSTANCES_OF_DAMAGE: 'Okolnosti nastanka',
    CAUSE_OF_DAMAGE: 'Uzrok štete *',
    PLEASE_SELECT: 'Molimo izaberite',
    ALLOWED_FILE_FORMATS: 'Dozvoljeni formati su: pdf, jp(e)g, bmp, png, tif(f), doc(x), rtf, xls(x) i txt.',
    FORMAT_NOT_ALLOWED: 'Format dokumenta nije odgovarajući',
    CLAIM_REPORTED: 'Za osigurano vozilo i datum nezgode već postoji ranije prijavljen zahtev.',
    userNotification: {
        CONFIRMATION_OF_APPLICANT: 'Potvrda podnosioca zahteva',
        RECIEVE_MESSAGE: 'Odaberite način za prijem jednokratne lozinke',
        SMS: 'SMS',
        EMAIL: 'Imejl',
        MSG_SENT: 'Poslali smo vam poruku/imejl',
        ONE_TIME_PASS: 'Jednokratna lozinka*',
        ERROR: 'Ne postoje podaci za unete kontakt podatke i privremenu lozinku!',
    },
    personalInfo: {
        CLAIM_SUBMITTED_BY: 'Zahtev podnosi',
        NAME: 'Ime *',
        LAST_NAME: 'Prezime *',
        UCN: 'JMBG',
        ADDRESS: 'Adresa',
        CITY: 'Mesto',
        MOBILE: 'Mobilni telefon (u obliku +3816xxxxxx)',
        MOBILE_STAR: 'Mobilni telefon (u obliku +3816xxxxxx) *',
        EMAIL: 'E-mail',
        EMAIL_STAR: 'E-mail *',
        SHOULD_WE_SEND_LINK: 'Da li želite da pošaljemo SMS sa linkom za samostalno snimanje štete? *',
        LINK_RECEPIENT: 'Na koji broj telefona da pošaljemo link? *',
        DID_YOU_DRIVE: 'Da li ste vi upravljali vozilom? *',
    },
    driverInfo: {
        DRIVER_INFO: 'Podaci o vozaču osiguranog vozila',
        NAME: 'Ime *',
        LAST_NAME: 'Prezime *',
        ADDRESS: 'Adresa',
        CITY: 'Mesto',
        MOBILE: 'Mobilni telefon (u obliku +3816xxxxxx)',
    },
    confirmationScreen: {
        ENSUREE:
            'Osiguravač nije u obavezi da pruži osiguravajuće pokriće niti da plati bilo kakav odštetni zahtev ili isplati bilo kakvu naknadu na osnovu ugovora o osiguranju u onoj meri u kojoj bi ga pružanje takvog pokrića, plaćanje takvog odštetnog zahteva ili omogućavanje takve naknade izložilo bilo kakvoj sankciji, zabrani ili ograničenju na osnovu rezolucija Ujedinjenih nacija ili trgovinskih ili ekonomskih sankcija, zakona ili propisa Evropske unije, Sjedinjenih Američkih država ili Republike Srbije.',
        SANCTIONS: 'Međunarodne sankcije',
        DATA: 'Obrada podataka o ličnosti',
        AGREEMENT:
            'Saglasan/-na sam da Generali Osiguranje Srbija a.d.o. sa mnom kontaktira, šalje mi korisne informacije, ponude i obaveštenja o proizvodima i uslugama osiguranja.',
        PRIVACY: 'Više o načinu na koji upravljamo vašim podacima možete pročitati u našoj ',
        PRIVACY_POLICY_LINK: 'Politici privatnosti',
        PRIVACY_POLICY_URL: 'https://www.generali.rs/footer.1056.html',
        WRONG_PASS: 'Neispravna lozinka. Proverite i pokušajte ponovo.',
    },
    success: {
        SUCCESS: 'Uspešno ste prijavili štetu',
        CLAIM_NUMBER: 'Broj štete je',
        NOTIFICATION_SEND: 'Potvrda o prijavi vam je poslata na imejl.',
    },
    vehicle: {
        YES: 'Da',
        NO: 'Ne',
        MECHANICS: 'Mehanika',
        ENTERIER: 'Enterijer',
        REST: 'Ostalo',
        SERVICE: 'Servis',
        ON_MY_ACC: 'Tekući račun',
        PLACE_AND_ADRESS: 'Mesto i adresa',
        NAME_AND_LOCATION: 'Naziv i mesto',
        DAMAGES: 'Oštećenja',
        VEHICLE_DRIVABLE: 'Da li je vozilo pokretno (u voznom stanju)?*',
        VEHICLE_LOCATION: 'Gde se nalazi vozilo?*',
        DAMAGE_ZONE: 'Označite na slici oštećenu/-e zone na vozilu*',
        DAMAGE_INFO:
            'Označite oštećenja nastala samo u konkretnom štetnom događaju. Osnovne informacije o oštećenjima su informativnog karaktera.',
        DAMAGE_DECLARATION: 'Ostavite napomenu u vezi oštećenja',
        REPAIR_SERVICE: 'Servis za popravku vozila',
        SERVICE_NAME: 'Naziv i mesto servisa gde nameravate da popravite vozilo',
        PAYMENT: 'Plaćanje',
        PAYMENT_RECEIVER: 'Kome da platimo štetu?',
    },
    validationMessages: {
        REQUIRED_FIELD: 'Obavezno polje',
        POLICY_OR_CHASSIS_NUMBER_REQUIRED: 'Molimo Vas da unesete broj polise ili broj šasije',
        POLICY_OR_CHASSIS_NUMBER_INVALID_FORMAT:
            'Molimo Vas da unesete broj polise ili broj šasije u odgovarajućem formatu',
        POLICY_NUMBER_INVALID:
            'Molimo Vas da unesete broj polise u odgovarajućem formatu (samo brojevi, najviše do 6 cifara)',
        PHONE_NUMBER_FORMAT: 'Potrebno je uneti broj telefona u odgovarajućem formatu (+3816xxxxxx)',
        EMAIL_ADDRESS_FORMAT: 'Potrebno je uneti e-mail adresu u odgovarajućem formatu (xx@xx.xx)',
        CONTACT_REQUIRED: 'Obavezno je uneti jedan kontakt podatak (email ili mobilni telefon)',
    },
    documentation: {
        ADD_DOC: 'Dodajte dokumenta u odgovarajuće kategorije',
        CHOOSE_DOC: 'odaberi dokument',
        TOTAL_UPLOAD_SIZE_LABEL: 'Ukupna veličina priloga koju možete poslati je ',
        TOTAL_UPLOAD_SIZE_LEFT_LABEL: 'Preostala veličina priloga koju možete poslati je ',
        DOCUMENTATION_MB_SPACE: ' MB.',
        ALLOWED_FILE_FORMATS: 'Dozvoljeni formati su: ',
        LOADING_MESSAGE: 'Podaci se prosleđuju. Molimo sačekajte.',
        COMPRESS_MESSAGE: 'Fajlovi se kompresuju. Molimo sačekajte.',
    },
    stepLabel: {
        START: 'Početak',
        DETAILS: 'Detalji',
        PERSONS: 'Lica',
        VEHICLE: 'Vozilo',
        DOCUMENTATION: 'Dokumentacija',
        CONFIRMATION: 'Potvrda',
        INTRO_START: 'Početak',
        INTRO_DOCUMENTATION: 'Dokumentacija',
        INTRO_CONFIRMATION: 'Saglasnost',
    },
    FULL_STOP: '.',
    intro: {
        INTRO_MESSAGE_1_TITLE: 'KAKO DA PRIJAVITE ŠTETU ONLAJN',
        INTRO_MESSAGE_1_LINE_1: 'Pripremite obavezna dokumenta navedena na sledećoj stranici',
        INTRO_MESSAGE_1_LINE_2: 'Popunite onlajn prijavu',
        INTRO_MESSAGE_1_LINE_3:
            'Na kraju prijave dobićete broj (npr. AK-1234/2025), koji je referenca za dalju komunikaciju',
        INTRO_MESSAGE_1_LINE_4: 'Odmah po slanju prijave, dobićete potvrdu putem imejla',
        INTRO_MESSAGE_1_LINE_5: 'Na istu imejl adresu stizaće vam sva obaveštenja i odluke o prijavi',
        INTRO_MESSAGE_1_LINE_6_1: 'Status i ishode možete pratiti na ',
        INTRO_MESSAGE_1_LINE_6_LINK_1: 'https://www.generali.rs/portal_za_klijente_.3646.html',
        INTRO_MESSAGE_1_LINE_6_2: 'Portalu za klijente',
        INTRO_MESSAGE_1_LINE_6_3: ' (fizička lica) ili ',
        INTRO_MESSAGE_1_LINE_6_LINK_2:
            'https://www.generali.rs/fizicka_lica/prijava_i_status_stete__naknade/provera_statusa_stetenaknade.1249.html',
        INTRO_MESSAGE_1_LINE_6_4: 'ovde',
        INTRO_MESSAGE_1_REMARK:
            'Napomena: Zahtev za nadoknadu podnosi oštećena strana u osiguravajućoj kući krivca za nezgodu.',

        // INTRO_MESSAGE_2_TITLE: 'OBAVEZNA DOKUMENTACIJA',
        // INTRO_MESSAGE_2_INTRO: 'Pripremite sledeću dokumentaciju:',
        // INTRO_MESSAGE_2_LINE_1: 'Evropski izveštaj o saobraćajnoj nezgodi (ukoliko je popunjen sa drugim učesnikom)',
        // INTRO_MESSAGE_2_LINE_2: 'Saobraćajnu dozvolu (kopija obe strane ili očitana)',
        // INTRO_MESSAGE_2_LINE_3: 'Kopija kartice tekućeg računa (ukoliko u prijavi izaberete isplatu na tekući račun)',
        // INTRO_MESSAGE_2_REMARK:
        //    'Skenirana dokumenta, fotografije i druge priloge možete poslati odmah putem onlajn prijave (korak „Dokumentacija“) ili naknadno, imejlom na adresu navedenu u imejlu o potvrdi prijave.',
    },
};

export const carImgData = [
    {
        num: 1,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 2,
        title: 'Far levi',
        img: leftFrontLight,
        active: 'false',
    },
    {
        num: 3,
        title: 'Branik prednji',
        img: frontBumper,
        active: 'false',
    },
    {
        num: 4,
        title: 'Far desni',
        img: rightFrontLight,
        active: 'false',
    },
    {
        num: 5,
        title: '',
        img: '',
        active: 'impossible',
    },

    {
        num: 6,
        title: 'Prednji točak levi',
        img: leftFrontWheel,
        active: 'false',
    },
    {
        num: 7,
        title: 'Krilo prednje levo',
        img: leftFrontWing,
        active: 'false',
    },
    {
        num: 8,
        title: 'Poklopac motora',
        img: hood,
        active: 'false',
    },
    {
        num: 9,
        title: 'Krilo prednje desno',
        img: rightFrontWing,
        active: 'false',
    },
    {
        num: 10,
        title: 'Prednji točak desni',
        img: rightFrontWheel,
        active: 'false',
    },
    {
        num: 11,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 12,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 13,
        title: 'Vetrobransko staklo',
        img: windshield,
        active: 'false',
    },
    {
        num: 14,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 15,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 16,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 17,
        title: 'Vrata prednja leva',
        img: leftFrontDoor,
        active: 'false',
    },

    {
        num: 18,
        title: 'Krov',
        img: roof,
        active: 'false',
    },
    {
        num: 19,
        title: 'Vrata prednja desna',
        img: rightFrontDoor,
        active: 'false',
    },
    {
        num: 20,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 21,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 22,
        title: 'Vrata zadnja leva',
        img: leftBackDoor,
        active: 'false',
    },
    {
        num: 23,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 24,
        title: 'Vrata zadnja desna',
        img: rightBackDoor,
        active: 'false',
    },
    {
        num: 25,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 26,
        title: 'Točak zadnji levi',
        img: leftBackWheel,
        active: 'false',
    },
    {
        num: 27,
        title: 'Krilo zadnje levo',
        img: leftBackWing,
        active: 'false',
    },
    {
        num: 28,
        title: 'Zadnje staklo',
        img: backGlass,
        active: 'false',
    },
    {
        num: 29,
        title: 'Krilo zadnje desno',
        img: rightBackWing,
        active: 'false',
    },
    {
        num: 30,
        title: 'Točak zadnji desni',
        img: rightBackWheel,
        active: 'false',
    },
    {
        num: 31,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 32,
        title: 'Zadnje svetlo levo',
        img: leftBackLight,
        active: 'false',
    },
    {
        num: 33,
        title: 'Poklopac zadnji',
        img: trunk,
        active: 'false',
    },
    {
        num: 34,
        title: 'Zadnje svetlo desno',
        img: rightBackLight,
        active: 'false',
    },
    {
        num: 35,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 36,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 37,
        title: '',
        img: '',
        active: 'impossible',
    },
    {
        num: 38,
        title: 'Branik zadnji',
        img: rearBumper,
        active: 'false',
    },
];

export const damageOptions = [
    {
        label: 'Mehanika',
        value: 'mehanika',
    },
    {
        label: 'Enterijer',
        value: 'enterijer',
    },
    {
        label: 'Ostalo',
        value: 'ostalo',
    },
];

export const question255MaxLength = 255;
export const question150MaxLength = 150;
export const questionMaxLength = 100;
export const question50MaxLength = 50;
export const question30MaxLength = 30;
export const question25MaxLength = 25;

export const nameMaxLength = 20;
export const surnameMaxLength = 30;
export const ucnMaxLength = 13;
export const phoneMaxLength = 15;
